import { getProjectPreviewUrl } from '@/Utils/ProjectUtility';
import { formatProductName } from '@/Utils/ProductUtility';

export default {
    data () {
        return {
            badProductStateNames: ['disabled'],
            goodProductStateNames: ['created', 'enabled'],
        };
    },
    props: {
        productId: { default: null, type: Number },
        focus: { default: false, type: Boolean },
    },
    methods: {
        getProductIdentifier(productID) {
            if (productID) {
                return `(${ productID })`;
            }

            return '';
        },
        getProductPublishedEvaluation(isProductPublished) {
            if (!isProductPublished)
                return 'bad';
            else
                return 'good';
        },
        formatProductName(product, productList) {
            return formatProductName(product, productList);
        },
        getAvailableProductTypes(productTypes, projectAdditionalInfo) {
            const availableTypes = { ...productTypes };

            if (!projectAdditionalInfo || !projectAdditionalInfo.digitalProductsEnabled) {
                delete availableTypes[availableTypes.digitalCode];
                delete availableTypes.digitalCode;
            }

            return availableTypes;
        },
        getAvailableProductTypeDisplayNames(productTypes, projectAdditionalInfo) {
            const availableTypes = this.getAvailableProductTypes(productTypes, projectAdditionalInfo);
            const result = {};

            // get only 'display name': id object
            for (const key of Object.keys(availableTypes)) {
                const id = Number(key);
                if (id >= 0) {
                    result[availableTypes[key].displayName] = id;
                }
            }

            return result;
        },
        buildProductPreviewUrl(productUrl, phase, languageIsoCode) {
            return getProjectPreviewUrl(productUrl, phase, languageIsoCode);
        },
        buildProductPreviewLabel(hasAvailableLanguages, currentLanguageIsoCode) {
            const text = 'view product page';
            if (hasAvailableLanguages) {
                return `${ text } (${ currentLanguageIsoCode })`;
            }
            return text;
        },
    },
    computed: {
        productID() {
            return this.productId;
        },
    },
};